import styled from 'styled-components'
import { colors } from 'styling/GlobalStyles'

export const DetailDrawer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 27.5rem;
  background: ${(props) => props.theme.appBackground};
  padding: 1.5rem;
  overflow-y: auto;
  z-index: 10000;
  box-shadow: -1rem 0 3rem rgba(0, 0, 0, 0.5);
  border-left: 1px solid ${(props) => props.theme.colorDividerDefault};
`

export const NodeRowInner = styled.div<{ $selected?: boolean; $depth: number }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.625rem;
  padding-left: ${(props) => 0.625 + props.$depth * 1.375}rem;
  border-radius: 0.625rem;
  cursor: pointer;
  background: ${(props) => (props.$selected ? colors.paleOrange : 'transparent')};
  border-bottom: 1px solid ${(props) => props.theme.colorDividerDefault};

  &:hover {
    background: ${(props) => (props.$selected ? colors.paleOrange : props.theme.colorSurface2 || 'rgba(255,255,255,0.04)')};
  }
`

export const ChevronSlot = styled.span`
  width: 1rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 0.875rem;
    height: 0.875rem;
    fill: ${(props) => props.theme.textFaded};
  }
`

export const UnmappedTag = styled.span`
  font-size: 0.625rem;
  color: ${colors.orange};
  border: 1px solid ${colors.paleOrange};
  border-radius: 6.25rem;
  padding: 0.0625rem 0.5rem;
`

export const DrawModeBar = styled.div`
  width: 100%;
  border: 1px solid ${(props) => props.theme.colorDividerDefault};
  background: ${(props) => props.theme.appBackground};
  border-radius: 0.75rem;
  padding: 0.75rem 1rem;
  margin-top: 1rem;
`

export const WarnBox = styled.div`
  border: 1px solid ${colors.paleOrange};
  background: ${colors.paleOrange};
  border-radius: 0.625rem;
  padding: 0.625rem 0.75rem;
  font-size: 0.8125rem;
  color: ${colors.orange};
  margin: 0.625rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const SectionLabel = styled.div`
  font-size: 0.6875rem;
  color: ${(props) => props.theme.textFaded};
  margin: 1rem 0 0.375rem;
  letter-spacing: 0.06rem;
  text-transform: uppercase;
`

export const AttrRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.4375rem 0;
  border-bottom: 1px solid ${(props) => props.theme.colorDividerDefault};
  font-size: 0.8125rem;
`

export const ModuleBindingRow = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 0.4375rem 0;
  border-bottom: 1px solid ${(props) => props.theme.colorDividerDefault};
  font-size: 0.78125rem;
`

export const MapContainer = styled.div`
  width: 100%;
`

export const MapLayout = styled.div`
  display: flex;
  gap: 1rem;
  align-items: stretch;
  width: 100%;
`

export const MapColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`

export const LocationsMapContainer = styled.div`
  width: 100%;
  height: 32rem;
  border-radius: 0.75rem;
  background-color: #1e2126;
  border: 1px solid ${(props) => props.theme.colorDividerDefault};
  overflow: hidden;
`

export const LocationsMapLoading = styled.div`
  width: 100%;
  height: 32rem;
  border-radius: 0.75rem;
  background-color: #1e2126;
  border: 1px solid ${(props) => props.theme.colorDividerDefault};
`

export const MapDrawSidebar = styled.div`
  width: 14rem;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
  border-radius: 0.75rem;
  border: 1px solid ${(props) => props.theme.colorDividerDefault};
  background: ${(props) => props.theme.appBackground};
`

export const LegendRow = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
  flex-wrap: wrap;
`

export const LegendDot = styled.span<{ $color: string }>`
  color: ${(props) => props.$color};
`

export const RegistryFooter = styled.div`
  display: flex;
  gap: 0.875rem;
  margin-top: 0.625rem;
  flex-wrap: wrap;
`

export const TypeTag = styled.span`
  display: inline-block;
  padding: 0.125rem 0.625rem;
  border-radius: 6.25rem;
  font-size: 0.6875rem;
  border: 1px solid ${colors.paleOrange};
  color: ${colors.orange};
  margin-left: 0.5rem;
`

